import { createReducer, on } from '@ngrx/store';
import * as authActions from '../actions/auth.actions';
import jwt_decode from 'jwt-decode';

export const initialAuthState: { isLoggedIn: boolean; token: string } = {
    isLoggedIn: false,
    token: '',
};

export const authReducer = createReducer(
    initialAuthState,
    on(authActions.SignInSuccess, (state, action) => {
        if (action.token !== undefined) {
            localStorage.setItem('token', action.token);
            return Object.assign(
                {},
                {
                    isLoggedIn: true,
                    token: action.token,
                }
            );
        } else {
            return Object.assign({}, action);
        }
    }),
    on(authActions.SignOut, () => initialAuthState)
);
